module.exports = __webpack_public_path__ + "img/introvideo-poster.f2bc67a5.png";